<template>
  <div class="input" :class="{'icon-before': iconBefore, social: social, outlined: outline}">
    <slot name="before"/>
    <ValidationProvider v-slot="{ errors }" :vid="vid" :rules="rules" class="provider">
      <div class="input-container" :class="{ error: errors[0] }">
        <input
          ref="input"
          class="input-container__input"
          :value="value"
          :type="type"
          :disabled="disabled"
          :readonly="readonly"
          autocomplete="off"
          @input="$emit('input', $event.target.value)"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
          @keypress="$emit('keypress', $event)"
          name="password"
        />
        <span class="placeholder" :class="{ not_empty: value }">
          {{ placeholder }}
        </span>
        <transition name="error">
          <p v-if="errors[0]" class="input-container__errors">
            {{ decodedError(errors[0]) }}
          </p>
        </transition>
        <slot/>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    vid: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: null
    },
    value: {
      type: [Number, String],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    iconBefore: {
      type: Boolean,
      default: false
    },
    social: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    focus(val) {
      if (val === true) {
        this.$refs.input.focus()
      }
    }
  },

  methods: {
    decodedError(error) {
      if (error.message) {
        return this.$t(`errors.${error.message}`, {n: error.value})
      }
      return this.$t(`errors.${error}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.input:focus-within {
  outline: 1px solid rgba(250, 197, 20, 1);
  box-shadow: 0 0 0 3px rgba(250, 197, 20, 0.2) !important;

}

.social {
  .provider {
    display: flex;
    align-items: center;
  }
}

@import '../../assets/scss/base/base_input.scss';
</style>



// WEBPACK FOOTER //
// src/components/base/BaseInput.vue